import type { TutorialStep } from "./types.ts";

/**
 * 「ルームごとの設定（ステータス・タグ）」チュートリアルのステップ定義。
 *
 * 各設定について「全体設定で追加 → タスクの詳細パネルで確認」の流れを
 * ステータス → タグ の順で 2 つ体験する。
 * （カスタム項目は別チュートリアル「カスタム項目の設定と表示」に分離）
 *
 * このチュートリアルでは練習用にプロジェクトとタスクを 1 件ずつ用意済み。
 * targetKey は SandboxScreen 側の data-tut 属性と対応する。
 */
export const SETTINGS_TUTORIAL_STEPS: TutorialStep[] = [
  {
    id: "welcome",
    targetKey: null,
    placement: "center",
    title: "ルームごとの設定を学ぶ",
    body:
      "ここでは「全体設定」で行う、チャットルームごとの設定を体験します。\n" +
      "ステータス・タグの2つについて、設定して → タスクの詳細画面で反映を確認する流れを順番に進めます。\n" +
      "練習用のプロジェクトとタスクはあらかじめ用意してあります。",
  },

  // ===== ① ステータス =====
  {
    id: "open-settings-status",
    targetKey: "settings-button",
    placement: "bottom",
    title: "① 全体設定を開く",
    body: "まずは画面右上の歯車「全体設定」ボタンを押して、設定画面を開きましょう。",
    expectAction: "open-settings",
  },
  {
    id: "settings-intro",
    targetKey: "settings-tabs",
    placement: "bottom",
    title: "全体設定の中身",
    body:
      "全体設定では、このルーム全体で使う「ステータス」「タグ」などを管理できます。\n" +
      "上部のタブで切り替えます。まずは開いている「ステータス設定」を見てみましょう。",
  },
  {
    id: "add-status",
    targetKey: "settings-add-status",
    placement: "top",
    title: "ステータスを追加する",
    body:
      "ステータスはタスクの進捗状態を表すラベルです。\n" +
      "入力欄に名前（例：「レビュー中」）を入力して「追加」を押してみましょう。",
    expectAction: "add-status",
  },
  {
    id: "close-settings-status",
    targetKey: "settings-close",
    placement: "left",
    title: "設定を閉じて確認する",
    body: "ステータスが追加できました。「閉じる」を押して、タスク側で反映を確認しましょう。",
    expectAction: "close-settings",
  },
  {
    id: "select-task",
    targetKey: "task-row",
    placement: "bottom",
    title: "タスクの詳細を開く",
    body: "タスクの行をクリックして、右側の詳細パネルを開きましょう。",
    expectAction: "select-task",
  },
  {
    id: "confirm-status",
    targetKey: "detail-panel",
    placement: "left",
    title: "ステータスを確認する",
    body:
      "詳細パネルのステータス欄をクリックして開いてみましょう。\n" +
      "先ほど追加した「レビュー中」が選択肢に増えているのを確認できたら、「次へ」を押してください。",
  },

  // ===== ② タグ =====
  {
    id: "open-settings-tag",
    targetKey: "settings-button",
    placement: "bottom",
    title: "② タグを設定する",
    body: "次はタグです。もう一度「全体設定」ボタンを押して設定画面を開きましょう。",
    expectAction: "open-settings",
  },
  {
    id: "open-tags-tab",
    targetKey: "settings-tab-tags",
    placement: "bottom",
    title: "タグ設定タブを開く",
    body: "上部の「タグ設定」タブをクリックしてください。",
    expectAction: "open-tags-tab",
  },
  {
    id: "add-tag",
    targetKey: "settings-add-tag",
    placement: "top",
    title: "タグを追加する",
    body:
      "タグはタスクに付けられるラベルです。色で見分けられます。\n" +
      "タグ名（例：「要確認」）を入力し、色を選んで「タグを追加」を押しましょう。",
    expectAction: "add-tag",
  },
  {
    id: "close-settings-tag",
    targetKey: "settings-close",
    placement: "left",
    title: "設定を閉じて確認する",
    body: "タグが追加できました。「閉じる」を押してタスク側で確認しましょう。",
    expectAction: "close-settings",
  },
  {
    id: "confirm-tag",
    targetKey: "detail-tags",
    placement: "left",
    title: "タグを確認する",
    body:
      "詳細パネルのタグ欄に、追加したタグが選べるようになっています。\n" +
      "クリックするとこのタスクにタグを付けられます。",
  },

  {
    id: "done",
    targetKey: null,
    placement: "center",
    title: "お疲れさまでした！",
    body:
      "ステータス・タグは、いずれも「全体設定」で追加すると、各タスクに反映されます。\n" +
      "どちらもルーム全体で共通の設定です。\n" +
      "「完了」を押すとチュートリアルを終了します。",
  },
];
